import { render, staticRenderFns } from "./AppMenuActions.vue?vue&type=template&id=f3eb10ec&scoped=true"
import script from "./AppMenuActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenuActions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppMenuActions.vue?vue&type=style&index=0&id=f3eb10ec&prod&scoped=true&lang=scss"
import style1 from "./AppMenuActions.vue?vue&type=style&index=1&id=f3eb10ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3eb10ec",
  null
  
)

export default component.exports